declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: (...args: any[]) => void
  }
}

const PIXEL_ID = '4459223280978091'

export function initMetaPixel(): void {
  if (typeof window === 'undefined' || window.fbq) return

  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  // Inject the script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  // Inject noscript fallback
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.body.appendChild(noscript)

  // Initialize and fire PageView
  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
}

/**
 * Fire a Meta Pixel event with multiple fallback strategies
 * to guarantee delivery.
 */
export function trackAddToCart(): void {
  // Strategy 1: Use fbq directly
  try {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'De Gamer a Creador',
        content_type: 'product',
        value: 6.39,
        currency: 'USD',
      })
      console.log('[Meta Pixel] AddToCart fired via fbq')
    }
  } catch (e) {
    console.warn('[Meta Pixel] fbq call failed:', e)
  }

  // Strategy 2: Image pixel fallback (always fires, no JS dependency)
  try {
    const img = new Image(1, 1)
    img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=AddToCart&noscript=1&cd[content_name]=De+Gamer+a+Creador&cd[content_type]=product&cd[value]=6.39&cd[currency]=USD&t=${Date.now()}`
    console.log('[Meta Pixel] AddToCart image pixel fired')
  } catch (e) {
    console.warn('[Meta Pixel] Image pixel fallback failed:', e)
  }
}

/**
 * Tracks AddToCart and then navigates after a delay
 */
export function trackAddToCartThenNavigate(url: string): void {
  trackAddToCart()
  setTimeout(() => {
    window.open(url, '_blank')
  }, 500)
}
